<div class="matero-container-wrap matero-header-above matero-navbar-side" [ngClass]="{
        'matero-sidenav-collapsed': options.sidenavCollapsed,
        'matero-header-white': options.theme === 'light'
      }" [dir]="options.dir">
  <ng-progress name="progress" aria-label="progress"></ng-progress>

  <!-- Header Above -->
  <app-navbar (toggleSidenav)="sidenav.toggle()" (optionsChange)="receiveOptions($event)" [isMobile]="isMobile">
  </app-navbar>

  <mat-sidenav-container class="matero-container" autosize autoFocus>
    <mat-sidenav #sidenav class="matero-sidenav" [mode]="isMobile ? 'over' : 'side'"
      [opened]="options.navPos === 'side' && options.sidenavOpened && !isMobile"
      (openedChange)="sidenavOpenedChange($event)" (closedStart)="sidenavCloseStart()" style="background-size: 85%;
                 background-repeat: no-repeat;
                 background-position: center bottom;
                 background-image: url(../../assets/images/OHA-Color.png)">
      <app-sidebar (toggleCollapsed)="toggleCollapsed()" [isMobile]="isMobile" [ripple]="!isMobile">
      </app-sidebar>
    </mat-sidenav>

    <mat-sidenav-content #content class="matero-content-wrap">

      <div class="matero-content">
        <router-outlet></router-outlet>
      </div>
      <!-- <div class="flex-grow"></div> -->

      <app-footer *ngIf="!isMobile" class="w-full fixed bottom-0"></app-footer>
    </mat-sidenav-content>

  </mat-sidenav-container>
</div>